import { state } from './state.js';
import { errorScreen } from './shell.js';

let resolve = () => { throw new Error('router not started'); };
let current = null;
let afterShow = () => {};
let seq = 0;

export function startRouter(resolver, shown = afterShow) {
  resolve = resolver;
  afterShow = shown;
  addEventListener('popstate', () => {
    state.nav = 'pop';
    render();
  });
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="/"]');
    if (!a || a.target || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    go(a.getAttribute('href'));
  });
  return render();
}

// Navigates within the app. `flash` is shown once, under the top bar of the next screen.
export function go(path, flash = '', { replace = false } = {}) {
  state.flash = flash;
  const depth = history.state?.depth ?? 0;
  state.nav = path === location.pathname + location.search ? 'same' : replace ? 'replace' : 'push';
  if (state.nav === 'push') history.pushState({ depth: depth + 1 }, '', path);
  else history.replaceState({ depth }, '', path);
  return render();
}

// Back within the app, or to the feed when the app was opened on this screen.
export function back() {
  if ((history.state?.depth ?? 0) > 0) history.back();
  else go('/');
}

export async function render() {
  const n = ++seq;
  const { view, params } = resolve(location.pathname);
  let next;
  try {
    next = await view(params ?? {});
  } catch (e) {
    next = errorScreen(e.message);
  }
  if (n !== seq) return next.cleanup?.(); // a newer navigation won
  current?.cleanup?.();
  current = next;
  document.getElementById('app').replaceChildren(next);
  scrollTo(0, 0);
  state.flash = '';
  afterShow();
}
